import { CSSProperties, ReactNode } from "react";
import styles from "./FormFieldWrapper.module.css";

type FormFieldWrapperProps = {
    label?: ReactNode;
    children: ReactNode;
    error?: ReactNode;
    containerStyle?: CSSProperties;
    labelAction?: ReactNode;
};

export default function FormFieldWrapper({
    label,
    children,
    error,
    containerStyle,
    labelAction,
}: FormFieldWrapperProps) {
    return (
        <div className={styles.wrapper} style={containerStyle}>
            {(label || labelAction) && (
                <div className={labelAction ? styles.labelRow : ''} style={{ marginBottom: '6px' }}>
                    {label}
                    {labelAction}
                </div>
            )}

            {children}
            {error}
        </div >
    );
}
